import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-normal transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-primary-500 text-primary-900',
        secondary: 'bg-canvas-soft text-text-secondary',
        destructive: 'bg-danger-500 text-white',
        outline: 'border border-border-light text-text-primary bg-background-secondary',
        link: 'bg-link-soft text-link',
      },
    },
    defaultVariants: {
      variant: 'secondary',
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
